// extracted by mini-css-extract-plugin
export var bottom = "bB_s";
export var contact = "bB_gr";
export var faqCat = "bB_gz";
export var faqCatDescription = "bB_gD";
export var faqCatTitle = "bB_gC";
export var faqCategories = "bB_gy";
export var faqIcon = "bB_gB";
export var footerText = "bB_cj";
export var icon = "bB_bv";
export var iconContainer = "bB_cs";
export var iconText = "bB_gt";
export var immediate = "bB_gs";
export var inputContainer = "bB_cL";
export var linksSubtitle = "bB_gw";
export var linksTitle = "bB_gv";
export var search = "bB_cF";
export var searchInput = "bB_cM";
export var section = "bB_d";
export var selected = "bB_bg";
export var supportButton = "bB_gF";
export var supportLinks = "bB_gx";
export var top = "bB_l";
export var wave = "bB_gq";